import React, { Component } from 'react';
import '../App.css';
import '../Style/General.css';
import '../Style/NeuralNetwork.css';
import { Panel } from 'react-bootstrap';
import Generator from '../Engines/Generator.js';

import Description from './Description.js';


const engines = new Map();
//Description of this group.
//This is what user will see by pressing the info icon.
const description = (
  <div>
    Our special Brand Name Generator generates new brand names from your query. The Generator is a neurological network that has analyzed hundreds of thousands of brand names. Click a suggestion to do a search with that brand name!
  </div>
)

class NeuralNetwork extends Component {
  constructor () {
    super();
    engines.set("Neuroverkko", {});
    this.state = {
      resultCount: 0,
      open: true,
    };
  }

  clear(){
    engines.set("Neuroverkko", {});
    this.setState({
      resultCount: 0,
      open: true,
    });
  }

  addResult(source, content, searchQuery) {
    if (engines.has(source)) {
      engines.set(source, content);
      this.setState({
        resultCount: this.state.resultCount + 1,
        noSearches: false
      });
    }
  }

  handleClick() {
    this.setState({open: !this.state.open});
  }

  getHeaderResults() {
    var amountOfSuggestions = '';
    var amount = engines.get("Neuroverkko").length;
    if(amount > 1){
      amountOfSuggestions = '' + amount;
    }
    else if(amount === 1) {
      amountOfSuggestions = '';
    }
    else{
      amountOfSuggestions = 'Loading';
    }
    return amountOfSuggestions;
  }

  header(){
    return(
      <div className="resultBox__header" onClick={ ()=> this.setState({ open: !this.state.open })}>
        <div className="resultBox__title">
          Name Generator
          <h2 className="resultBox__title results">{this.getHeaderResults()} Ideas</h2>
          </div>
      </div>
    );
  }

  render() {
      return (
        <Panel className="resultBox" collapsible expanded={this.state.open} header={this.header()}>
          <div className='resultBox__content clearfix'>
            <div className='Description'>
              {description}
            </div>
            <div className='NeuralDiv'>
              <Generator content={engines.get("Neuroverkko")} />
            </div>
          </div>
          <div className="resultBox__footer">

          <div className="hide__help_700px">
            <div className="resultBox__help">
              <Description description={description}/>
              <p>What is this report about?</p>
            </div>
          </div>

          </div>
        </Panel>
      );
  }
}

export default NeuralNetwork;



// WEBPACK FOOTER //
// ./client/src/Groups/NeuralNetwork.js